import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit'

/**
 * Gets the products list
 */
export const getProducts = factoryService(({ name }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/catalogo/productos?query=${name}`)
)

/**
 * Gets a list of categories of the goods and services.
 */
export const getCategories = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/catalogo/categorias/clasificadores`)
)

/**
 * Gets a list of categories of level two of the goods and services.
 */
export const getCategoriesLevelTwo = factoryService(({ category }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/catalogo/categorias/clasificadores/${category}`)
)

/**
 * Gets a list of goods and services by category.
 */
export const getGoodsAndServicesByCategory = factoryService(({ category }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/catalogo/categorias/${category}/productos`)
)

/**
 * Gets a boolean of products with fragmentation alert .
 */
export const getFragmentationAlert = factoryService(({ ...payload }) => {
  const body = {
    productos: payload.productsCode
  }
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/alertaFragmentacionCompras`, { body })
})
